import { getSelectAgeInOneRowTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const selectAgeInOneRowConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Age CTA #2",
    body: {
      type: "panel",
      items: [
        {
          type: "selectbox",
          name: "count",
          label: "Buttons count",
          items: [
            { value: "3", text: "3" },
            { value: "4", text: "4" },
          ],
        },
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
        {
          type: "colorinput",
          name: "hoverColor",
          label: "Hover color",
        },
        {
          type: "grid",
          columns: 2,
          items: [
            {
              type: "input",
              name: "cornerRadius",
              label: "Corner radius (px)",
            },
            {
              type: "input",
              name: "buttonSpacing",
              label: "Spacing on mobile (px)",
            },
          ],
        },
      ],
    },
    initialData: {
      bgColor: "#28b02b",
      hoverColor: "#28b02b",
      cornerRadius: "8",
      buttonSpacing: "23",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      const cornerRadius = Number.parseInt(data.cornerRadius, 10);
      const buttonSpacing = Number.parseInt(data.buttonSpacing, 10);

      const templateToAdd = getSelectAgeInOneRowTemplate({
        url: data.url,
        count: data.count,
        tab: data.openLink,
        bgColor: data.bgColor,
        hoverColor: data.hoverColor,
        cornerRadius: Number.isFinite(cornerRadius) && cornerRadius >= 0 ? cornerRadius : 8,
        buttonSpacing: Number.isFinite(buttonSpacing) && buttonSpacing >= 0 ? buttonSpacing : 23,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { selectAgeInOneRowConfig };
